/// <reference path="../../app.definition.ts" />

import { Serializable } from "./Serializable";

export class FormDisplayOption implements Serializable<FormDisplayOption> {
    width: string;
    transformCase: string;
    webType: string;
    text: string;
    fontSize: string;
    alignment: string;

    constructor(input?: any) {
        !!input && this.deserialize(input);
    }

    deserialize(input: any) {
        !!input.width && (this.width = input.width);
        !!input.transformCase && (this.transformCase = input.transformCase);
        !!input.webType && (this.webType = input.webType);
        !!input.text && (this.text = input.text);
        !!input.fontSize && (this.fontSize = input.fontSize);
        !!input.alignment && (this.alignment = input.alignment);

        return this;
    }
}
